import { useQuery } from '@tanstack/react-query';
import { validatedApi } from '../../../lib/api/validated-client';
import type { FeaturedReviewsResponse } from '@lov/shared';

/**
 * Hook to fetch featured reviews for the landing page testimonials section.
 *
 * Calls GET /api/reviews/featured and returns the list of featured reviews
 * with loading and error state.
 */
export function useFeaturedReviews() {
  const { data, isLoading, error } = useQuery<FeaturedReviewsResponse>({
    queryKey: ['reviews', 'featured'],
    queryFn: async () => {
      return validatedApi.get('/reviews/featured');
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  return {
    reviews: data?.data ?? [],
    isLoading,
    error,
  };
}
